var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef, useImperativeHandle, useRef } from "react";
import styled from "styled-components";
const StyledInput = styled.input `
	font-weight: bold;
	width: 500px;
	height: 25px;
	margin: 0 0 .5em 0;
	border: none;
	border-bottom: 1px solid #ddd;
	padding: 2px 2px 5px 28px;
	outline: none;

	&::placeholder {
		font-weight: normal;
		font-style: italic;
	}
`;
const SearchBox = forwardRef(function SearchBox(_a, ref) {
    var { query = "", scorerName } = _a, props = __rest(_a, ["query", "scorerName"]);
    const inputRef = useRef(null);
    useImperativeHandle(ref, () => ({
        focus() { var _a; (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.focus(); }
    }));
    return (React.createElement(StyledInput, Object.assign({ type: "search", ref: inputRef, tabIndex: 0, placeholder: `Search for a title or URL using ${scorerName}`, spellCheck: false, value: query }, props)));
});
export default SearchBox;
